import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useBrandProperties } from "../brandPropertiesHook/useBrandProperties";

const BrandPropertiesInstructions = () => {
  const { formattedBrandProperties } = useBrandProperties();
  return (
    <>
      <Paper sx={{ width: "260px", boxShadow: "none", p: 0 }}>
        <Box display="flex" flexWrap="wrap" padding="16px">
          <Typography variant="h6" mb={1}>
            Instructions
          </Typography>
          <Typography variant="body1" fontSize={14}>
            Here you can find Instructions on how to fill each field of brand
            properties and where to find the relevant information.
          </Typography>
        </Box>
        {formattedBrandProperties?.length > 0 ? (
          formattedBrandProperties.map((item: any) => (
            <Box
              sx={{ overflow: "auto", maxHeight: "85vh", px: "16px" }}
              key={item.label}
            >
              <Typography variant="h6" color="secondary" mb={1}>
                {item.label}
              </Typography>
              <Typography variant="body1" fontSize={14} mb={2}>
                {item.description}
              </Typography>
            </Box>
          ))
        ) : (
          <>
            <Box sx={{ overflow: "auto", maxHeight: "85vh", px: "16px" }}>
              <Typography variant="h6" color="secondary" mb={1}>
                Will be ready soon...
              </Typography>
            </Box>
          </>
        )}
      </Paper>
    </>
  );
};

export default BrandPropertiesInstructions;
